import { ApolloClient, ApolloLink, InMemoryCache, from, split } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { coastguardInstance } from "./security";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { showSnackbar } from "@cofano/cck";

// Makes sure that typename is added when querying results and removed when mutating
const omitTypenameLink = new ApolloLink((operation, forward) => {

	operation.variables = JSON.parse(
		JSON.stringify(operation.variables),
		(key, value) => key === "__typename" ? undefined : value,
	);

	return forward(operation);
});

const cache = new InMemoryCache({
	possibleTypes: {
		Agreement: [ "AgreementWithUnit" ],
	},
	addTypename: false,
});

const httpLink = createUploadLink({
	uri: ({ operationName }) => `/api/graphql?op=${operationName}`,
	credentials: "include",
	fetch: coastguardInstance.fetch,
});

// WebSocket link for subscriptions
const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";
const wsLink = new GraphQLWsLink(createClient({
	url: `${wsProtocol}://${window.location.host}/api/subscriptions`,
	lazy: true,
	connectionParams: () => ({
		token: coastguardInstance.getAccessToken,
	}),
}));

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
	if (operation.variables.noError) {
		return;
	}
	if (operation.getContext().silentError?.(graphQLErrors)) {
		return; // handle errors locally in component
	}
	if (graphQLErrors) {
		graphQLErrors.forEach(e => {
			showSnackbar(e.message, { variant: "error" });
		});
	}
	if (networkError) {
		//for testing purposes
		console.log(networkError);
	}
});

const splitLink = split(
	({ query }) => {
		const def = getMainDefinition(query);
		return def.kind === "OperationDefinition" && def.operation === "subscription";
	},
	wsLink,
	httpLink,
);

const client = new ApolloClient({
	link: from([ errorLink, omitTypenameLink, splitLink ]),
	cache: cache,
	defaultOptions: {
		query: {
			fetchPolicy: "no-cache",
			notifyOnNetworkStatusChange: true,
		},
		watchQuery: {
			fetchPolicy: "no-cache",
			notifyOnNetworkStatusChange: true,
		},
		mutate: {
			fetchPolicy: "no-cache",
		},
	},
	connectToDevTools: true,
});

export default client;
